import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Культура';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>В области бережно относятся к памятникам архитектуры. В Бресте - Братская и Симеоновская церкви,
                        в Барановичах - Покровский собор и Крестовоздвиженский костел, в Пинске - Варваринская церковь,
                        костел и коллегиум иезуитов, монастырь францисканцев. Город Каменец трудно представить без
                        знаменитой Каменецкой башни.</p>
                    <p>Символом Бреста является Брестская крепость. Она была введена в строй в 1842 году и является
                        прекрасным примером фортификационного искусства того времени. Но истинную свою славу крепость
                        приобрела, когда в июне-июле 1941 года ее гарнизон проявил выдающуюся воинскую доблесть,
                        массовый героизм и мужество в борьбе с немецко-фашистскими захватчиками. Брестской крепости
                        присвоено высокое звание «Крепость-герой». 25 сентября 1971 года в торжественной обстановке был
                        открыт «Мемориальный комплекс «Брестская крепость-герой».</p>
                    <p>В 1982 году на месте раскопок на территории крепости открылся археологический музей «Берестье».
                        Здесь законсервированы древние строения десятого-одиннадцатого столетий. Над ними воздвигнута
                        стеклянная крыша оригинальной конструкции.</p>
                    <p>На Берестейщине немало памятных мест, связанных с именами Адама Мицкевича, Наполеона Орды,
                        Казимира Лыщинского, Тадеуша Костюшки, Михаила Огинского и других. </p>
                    <p>Брест — начало Белой Руси, сюда часто приезжают, чтобы посмотреть на удивительно сохранившееся
                        славянское городище XI века.</p>
                </div>
            </div>
        </>
    );
}